/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Hotel_DescriptionInputs */

const en_map_hotel_description = /** @type {(inputs: Map_Hotel_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multi-storey hotel: lobby and two guest floors, two lifts, three robot fleets.`)
};

const fr_map_hotel_description = /** @type {(inputs: Map_Hotel_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hôtel multi-étages : un lobby et deux étages clients, deux ascenseurs, trois flottes de robots.`)
};

const ms_sg2_map_hotel_description = /** @type {(inputs: Map_Hotel_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hotel berbilang tingkat: lobi dan dua tingkat tetamu, dua lif, tiga armada robot.`)
};

/**
* | output |
* | --- |
* | "Multi-storey hotel: lobby and two guest floors, two lifts, three robot fleets." |
*
* @param {Map_Hotel_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const map_hotel_description = /** @type {((inputs?: Map_Hotel_DescriptionInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Hotel_DescriptionInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_map_hotel_description(inputs)
	if (locale === "fr") return fr_map_hotel_description(inputs)
	return ms_sg2_map_hotel_description(inputs)
});